import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { newChatMessage } from './actions';
const reducers = handleActions({
    [`${newChatMessage}`]: (state, action)=>true
}, false);
export default {
    [reduxKey]: reducers
};
